<template>

<app-table-cell class="days">

    <div class="days-item" v-for="day in days" :key="day.value" v-tooltip="day.text" :class="{'is-active': $_.contains(active, day.value) || (emptyIsAll && !active.length)}">{{ day.short }}</div>
    
</app-table-cell>
    
</template>
    
<script>
    
export default {
    
    props: ['days', 'active', 'emptyIsAll']
    
}
    
</script>
    
<style scoped>

.days {
    display: flex;
    justify-content: center;
    align-items: center;
}

.days-item {
    width: 24px;
    margin: 1px;
    height: 24px;
    border-radius: 4px;
    background-color: #ddd;
    line-height: 24px;
    text-align: center;
    font-weight: 500;
    font-size: 12px;
    color: #999;
}

.days-item.is-active {
    color: #fff;
    background-color: #4082d3;
}
    
</style>